<template>
  <div class="case-recommend">
    <a-descriptions layout="vertical" :column="2">
      <a-descriptions-item label="用例名称" :span="2">
        <span v-if="recommendCase.name" class="precondition">{{ recommendCase.name }}</span>
        <span v-else>--</span>
      </a-descriptions-item>
      <a-descriptions-item label="前置条件" :span="2">
        <span v-if="recommendCase.precondition" class="precondition">{{ recommendCase.precondition }}</span>
        <span v-else>--</span>
      </a-descriptions-item>
      <a-descriptions-item label="操作步骤" :span="2">
        <a-table size="middle" class="steps_table" :pagination="false" :columns="columns" :data-source="recommendCase.steps" :row-key="(_, index) => index">
          <template slot="step" slot-scope="text, record">
            <span v-if="record.step" v-html="record.step.replace(/\n/g, '<br>')" />
          </template>
          <template slot="result" slot-scope="text, record">
            <span v-if="record.result" v-html="record.result.replace(/\n/g, '<br>')" />
          </template>
        </a-table>
      </a-descriptions-item>
      <a-descriptions-item label="备注" :span="2">
        <vditor-preview :content="recommendCase.description === null ? '' : recommendCase.description" />
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
import VditorPreview from '@/components/VditorEditor/preview';

const columns = [
  {
    title: '序号',
    dataIndex: 'number',
    key: 'number',
    align: 'center',
    width: 60,
    customRender: (_text, _row, index) => {
      return index + 1;
    }
  },
  {
    width: 400,
    key: 'step',
    title: '操作步骤',
    dataIndex: 'step',
    scopedSlots: { customRender: 'step' }
  },
  {
    width: 400,
    key: 'result',
    title: '预期结果',
    dataIndex: 'result',
    scopedSlots: { customRender: 'result' }
  }
];

export default {
  name: 'CaseRecommend',
  components: {
    VditorPreview
  },
  props: {
    changeCase: {
      type: [String, Object]
    }
  },
  data() {
    return {
      columns,
      recommendCase: {}
    };
  },
  watch: {
    changeCase: {
      handler(val) {
        if (typeof val === 'string') {
          try {
            this.recommendCase = JSON.parse(val);
          } catch (e) {
            console.error('Failed to parse changeCase:', e);
            this.recommendCase = {};
          }
        } else {
          this.recommendCase = val || {};
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped>
.case-recommend {
  padding: 16px;

  .precondition {
    white-space: pre-wrap;
    word-break: break-all;
  }

  .steps_table {
    margin: 8px 0;
  }
}
</style>
